var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-User-Management_02",
    transform: "translate(-1581.000000, -31.000000)",
    fill: "#8F9BA9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591,31 C1585.48,31 1581,35.48 1581,41 C1581,46.52 1585.48,51 1591,51 C1596.52,51 1601,46.52 1601,41 C1601,35.48 1596.52,31 1591,31 Z M1592,48 L1590,48 L1590,46 L1592,46 L1592,48 Z M1594.07,40.25 L1593.17,41.17 C1592.45,41.9 1592,42.5 1592,44 L1590,44 L1590,43.5 C1590,42.4 1590.45,41.4 1591.17,40.67 L1592.41,39.41 C1592.78,39.05 1593,38.55 1593,38 C1593,36.9 1592.1,36 1591,36 C1589.9,36 1589,36.9 1589,38 L1587,38 C1587,35.79 1588.79,34 1591,34 C1593.21,34 1595,35.79 1595,38 C1595,38.88 1594.64,39.68 1594.07,40.25 Z",
    id: "Infomaion"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.3152a352a62e8a3053dda51f40bf2599.svg";
export { ForwardRef as ReactComponent };